import axios from "axios";

export interface IProcurementItem {
  id: number;
  // The incoming stock-PO line (mirror row id) a cart line was pointed at, if any.
  incoming_po_item?: number | null;
  estimate_id: number;
  boq_item: string;
  item_description: string;
  item_image?: string;
  product_handle?: string;
  variant_handle?: string;
  vendor: any;
  hsn_code?: string;
  unit?: string;
  brand?: string;
  category_name?: string;
  unit_cost_price: number;
  mrp: number;
  unit_selling_price: number;
  landing_price: number;
  variant: number | null;
  total_price: number;
  quantity: number;
  margin?: number;
  tax_value?: number;
  procurement_poc_id: string;
  lead_time: number | null;
  predicted_lead_time?: number | null;
  predicted_quantity?: number | null;
  prediction_reasoning?: string | null;
  remarks?: string;
  tax_type?: string;
  is_deleted: boolean;
  deleted_by_id: string | null;
  lead_id?: string;
  estimate_no: string;
  created_at: string;
  total_stock?: number;
  // selected_vendor_ware_house?: any;
  selected_vendor_ware_house_id?: number;
  selected_vendor_id?: number;
}

export interface IDeliveryItem {
  id: number;
  po_number: string;
  lead_id: string;
  created_by_id: string;
  type_of_order: string;
  delivery_date: string;
  branch_id: number;
  estimate_id: number;
  vendor: number;
  terms_and_condition_id: number;
  terms_and_condition_description: string;
  total_po_raised_amount: number;
  created_at: string;
  modified_at: string;
  is_decline: boolean;
  decline_by_id: string | null;
  is_deleted: boolean;
  deleted_by_id: string | null;
  is_revised: boolean;
  revised_by_id: string | null;
  gst_id: number;
  address: number;
  address_description: string;
  is_accepted: boolean;
  is_approved: boolean;
  is_pending: boolean;
  po_pdf: string;
  migration_id: unknown;
  porter_booking_time: string | null;
  procurement_poc_id: string;
  old_attachment: unknown;
  dispatch_time: string;
  po_delivery_status: string;
  remark: string | null;
  live_location_link: string | null;
  estimate_no: string;
}

export async function getCartItemDetails(params: Record<string, any>) {
  console.log("params", params);
  try {
    const response = await axios.get<Array<any>>(
      `${process.env.REACT_APP_API_URL}/cart-item-details/`,
      {
        params,
      }
    );
    return response.data;
  } catch (e) {
    return [];
  }
}

export async function getCartItemDetailsPredicted(params: Record<string, any>) {
  console.log("params", params);
  try {
    const response = await axios.get<Array<any>>(
      `${process.env.REACT_APP_API_URL}/cart-item-details-predicted/`,
      {
        params,
      }
    );
    return response.data;
  } catch (e) {
    return [];
  }
}

// Sellable list: whether the allocator may auto-fill carts from a variant's
// VendorInventory. Stock is always SHOWN; this only decides what gets promised.
export async function setAutoFillAllowed(variantId: number, enabled: boolean) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/vendor-inventory/sellable/by-variant/`,
    { variant_id: variantId, enabled }
  );
  return response.data;
}

export async function editCartItemDetails(payload: any) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/cart-item-details/`,
      payload
    );
    return response.data;
  } catch (e) {
    return null;
  }
}

export const fetchProcurementDashboardData = async (
  id?: string,
  search?: string,
  page?: number
) => {
  try {
    const response = await axios.get<any>(`${process.env.REACT_APP_API_URL}/procurement-poc-dashboard/`, {
      params: { procurement_poc_id: id, search: search, page: page },
    });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const fetchProcurementDashboardDataNew = async (
  id?: string,
  search?: string,
  page?: number
) => {
  try {
    const response = await axios.get<any>(
      `${process.env.REACT_APP_API_URL}/procurement-poc-dashboard-new/`,
      {
        params: { procurement_poc_id: id, search: search, page: page },
      }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const fetchProcurementEstimateItemDetails = async (
  id?: string,
  search?: string,
  page?: number,
  onlyBlanks?: boolean
) => {
  try {
    const params = {
      procurement_poc_id: id,
      search: search,
      page: page,
    } as Record<string, any>;
    if (onlyBlanks) {
      // params["only_blanks"] = true;
      params["order_placed"] = true;
    }
    const response = await axios.get<any>(
      `${process.env.REACT_APP_API_URL}/estimate-item-details/`,
      {
        params,
      }
    );

    return response.data;
  } catch (e) {
    return null;
  }
};

export const editProcurementEstimateItemDetails = async (payload: any) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/estimate-item-details/`,
      payload
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const fetchProcurementDeliveryData = async (id?: string) => {
  try {
    const response = await axios.get<Array<IProcurementItem>>(
      `${process.env.REACT_APP_API_URL}/procurement-delivery-dashboard/`,
      {
        params: id ? { procurement_poc_id: id } : {},
      }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const fetchProcurementPayments = async (params?: Record<string, any>) => {
  try {
    const response = await axios.get<any>(
      `${process.env.REACT_APP_API_URL}/procurement/payments/`,
      { params }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const authorizeProcurementPayment = async (id: number, payload: { payment_id?: string; payment_method?: string; payment_medium?: string; payment_amount?: number; created_at?: string }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/procurement/payments/${id}/`,
      payload
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const rejectProcurementPayment = async (id: number, reason: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/procurement/payments/${id}/reject/`,
      { reason }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const bulkAuthorizeProcurementPayments = async (paymentIds: number[], updateFields: { payment_id?: string; payment_method?: string; payment_medium?: string; payment_amount?: number; created_at?: string }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/procurement/payments/bulk-authorize/`,
      {
        payment_ids: paymentIds,
        update_fields: updateFields
      }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const bulkAuthorizePaymentsFromSheet = async (
  sheetUrl: string,
  sheetTab?: string,
  dryRun: boolean = false,
  planToken?: string
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/procurement/payments/bulk-authorize/`,
      {
        sheet_url: sheetUrl,
        sheet_tab: sheetTab || undefined,
        dry_run: dryRun,
        plan_token: planToken,
      }
    );
    return response.data;
  } catch (e: any) {
    return {
      error: e?.response?.data?.error || 'Request failed',
      errors: e?.response?.data?.errors,
      status: e?.response?.status,
    };
  }
};

export const fetchProcurementCredits = async (params?: Record<string, any>) => {
  try {
    const response = await axios.get<any>(
      `${process.env.REACT_APP_API_URL}/procurement/credit/`,
      { params }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const fetchProcurementCreditClients = async (params?: Record<string, any>) => {
  try {
    const response = await axios.get<any>(
      `${process.env.REACT_APP_API_URL}/procurement/credit/clients/`,
      { params }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const fetchProcurementCreditClientOrders = async (clientId: string) => {
  try {
    const response = await axios.get<any>(
      `${process.env.REACT_APP_API_URL}/procurement/credit/clients/${clientId}/`
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const payProcurementCreditClient = async (
  clientId: string,
  payload: {
    payment_amount: number;
    payment_method: string;
    payment_medium?: string;
    payment_id?: string;
    created_at?: string;
  }
) => {
  try {
    const response = await axios.post<any>(
      `${process.env.REACT_APP_API_URL}/procurement/credit/clients/${clientId}/pay/`,
      payload
    );
    return response.data;
  } catch (e: any) {
    return { error: e?.response?.data?.error || 'Failed to record payment' };
  }
};

export const getDailyLeadTimeMetrics = async () => {
  try {
    const response = await axios.get<any>(
      `${process.env.REACT_APP_API_URL}/get-daily-lead-time-metrics/`
    );
    return response.data;
  } catch (e) {
    return null;
  }
};
export interface ZohoBackfillRow {
  ept_id: number;
  estimate_id: number | null;
  lead_id: string | null;
  payment_id: string | null;
  medium: string | null;
  mode: string | null;
  status: string;
  amount: number;
  created_at: string;
}

export interface ZohoBackfillSummary {
  since: string;
  pending: number;
  pending_amount: number;
  oldest_created_at: string | null;
  by_medium: { medium: string; count: number; amount: number }[];
  rows: ZohoBackfillRow[];
}

export interface ZohoBackfillRunResult extends ZohoBackfillSummary {
  status: "ok" | "busy";
  message?: string;
  dry_run?: boolean;
  attempted?: number;
  pushed?: number;
  skipped?: number;
  errors?: number;
  pushed_amount?: number;
  remaining?: number;
  details?: { ept_id: number; lead_id?: string; outcome: string; detail?: string }[];
}

// Returns null on failure — the caller must show "couldn't check", never "0 pending".
// Telling finance nothing is outstanding when the request failed is the one wrong
// answer this panel can give.
export const fetchZohoPaymentBackfillStatus = async (
  since?: string
): Promise<ZohoBackfillSummary | null> => {
  try {
    const response = await axios.get<ZohoBackfillSummary>(
      `${process.env.REACT_APP_API_URL}/procurement/zoho-payment-backfill/`,
      { params: since ? { since } : undefined }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const runZohoPaymentBackfill = async (
  limit?: number,
  since?: string
): Promise<ZohoBackfillRunResult | null> => {
  try {
    const response = await axios.post<ZohoBackfillRunResult>(
      `${process.env.REACT_APP_API_URL}/procurement/zoho-payment-backfill/`,
      { limit, since }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};
